import React,{Component} from 'react';
import {Link} from 'react-router-dom';
import person from '../assets/images/peopple/person.png';

export default class Testimony extends Component{
    render(){
        const {isTestimony, title, subHeading, buttonText, testimony, isButton, url} = this.props;        
        const testimonial = testimony.map((testimonial,i) => 
            <div className="testimonial" key={i}>
                {testimonial.message}
                <div className="tester">
                    <img src={testimonial.imgSrc} />
                    <div className="text">
                        <h4>{testimonial.name}</h4>
                        <h5>{testimonial.title}</h5>
                    </div>
                </div>
            </div>
        )
        return(
            <div id="testimony">
                {isTestimony &&     
                <div>        
                    <div className="txt-head">
                        <h3>Apa Kata Mereka?</h3>
                    </div>
                    <div className="container">
                        {testimonial}
                    </div>
                </div>
                }
                <div className="signUp_section">
                    <div className="text_middle">
                        <h3 className="text_rubik">{title}</h3>
                        <p>{subHeading}</p>
                        <div className="signUp-form">
                            <Link to={url}>
                                {isButton && <button className="sign_free">{buttonText}</button>}
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/Testimony.js